angular.module("app").controller("ProductsListController", [
    '$scope',
    'preloadedProductsList',
    'productsService',
    'errorHandler',
    'logger',
    '$timeout',
    'pageStatuses',
    '$state',
    'pagination',
    '$uibModal',
    'settingsService',
    '$cookies',
    'userStorage',
    function ($scope,
              preloadedProductsList,
              productsService,
              errorHandler,
              logger,
              $timeout,
              pageStatuses,
              $state,
              pagination,
              $modal,
              settingsService,
              $cookies,
              userStorage) {

        var settings =  settingsService.getSettings(),
            pendingListRequest;


        preloadedProductsList = preloadedProductsList || {};

        $scope.pageStatuses = pageStatuses;
        $scope.filterOptions = {
            status: $scope.pageStatuses[0]
        };
        $scope.staate = $state;
        $scope.products = preloadedProductsList.products;
        var initialOrders = getValuesByKey($scope.products, 'order');

        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.allowUpdateContainer = {};
        $scope.allowUpdateContainer.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            } else if (!!options) {
                $scope.tabOptions.reordered = true;
            }
        };

        function reorder () {
            if (typeof $scope.products === "object" && $scope.products.length) {
                reorderByService({
                    ids: getValuesByKey($scope.products, 'id'),
                    orders: initialOrders
                }, productsService);
            }
        }

        function reorderByService (orderData, service) {
            service.changeOrder({
                orderData: orderData
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        $scope.ignoreColumns = {
            'alias': true,
            'id': true,
            'images': true,
            'status': true,
            'description': true,
            'created_at': true,
            'order': true,
            'on_top': true
        };
        
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, preloadedProductsList.total_count, 25);

        $scope.updateList = function (externalOptions) {
            var requestObject = {
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status
            };

            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions)
            }
            settingsService.setFilters(requestObject);
            productsService.getProducts(requestObject).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.products = angular.copy(response.products);
                        $scope.pagination.totalItems = response.total_count;
                        initialOrders = getValuesByKey($scope.products, 'order');

                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
        
        $scope.editProduct = function (product) {
            $modal.open({
                templateUrl: "views/products/exchange/edit.html",
                controller: "EditProductController",
                resolve: {
                    preloadedProductData: function (productsService, errorHandler, settingsService, $cookies) {
                        if (!product.id && product.id != 0) {
                            return {}
                        } else {
                            return productsService.getProducts({
                                product_id: product.id,
                                lang: $cookies.get("preferedLanguage") || settingsService.getSettings().skin.defaultLang
                            }).then(
                                function (response) {
                                    if (response.status === "ok") {
                                        return (response.product) ? response.product : {}
                                    }
                                    errorHandler(response.message);
                                    return {}
                                },
                                function (response) {
                                    errorHandler(response.message)
                                }
                            )
                        }
                    }
                }
            }).result.then(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    lang: $cookies.get("preferedLanguage"),
                    limit: $scope.pagination.limit
                })
            });
        };
        if (userStorage.getUserData().permissions.indexOf('manageProducts') !== -1) {
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.editProduct(item, true);
                    }

                }
            };
        }


        $scope.listFilterObject = {
            action: function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }
        };

    }

]);
